// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 592 ? "7a49ec60" : chunkId) + "." + {"88":"52af331d5366928c","122":"77c09fb7f20d5016","592":"82271a60a07898c1"}[chunkId] + ".js";
};